import { memo } from 'react';

import Styled from '@/components/atomic/atoms/navigation/bar/styled';
import type { BarProps } from '@/components/atomic/atoms/navigation/bar/typings';
import withExposer from '@/hocs/with-exposer';
import type { BasicComponentProps } from '@/typings/generic';

const BarComponent: React.FC<BarProps & BasicComponentProps> = (props) => (
	<Styled {...props} />
);

const Bar = memo(withExposer(BarComponent, 'bar'));

export default Bar;
